export function getProductIdFromPath(url: string): number | null {
  const match = url?.match(/products\/(\d+)-/);

  if (match && match.length >= 2) {
    return Number(match[1]);
  } else {
    return null;
  }
}
